const trackingUtils = require('../modules/utils/tracking.utils');
const tripTypeUtils = require('../modules/utils/trip_type').ofResults();
const tripTypeToResultsType = require('../modules/utils/trip_type').toResultsType;

const PAGES_TO_TRACK = {
    flightsummary: 'sum',
    details: 'pax',
    passengersinfo: 'pax',
    payment: 'pay',
    confirmation: 'conf',
    cancellation: 'can',
    flex: 'flex',
    servicepack: 'sp',
    insurance: 'ins',
    ancillaries: 'anc',
};

const getFilteredVinFlights = (itineraries) => {
    return itineraries.filter((itinerary) => Odigeo.Utils.isVinFlight(itinerary.fareItineraryType));
};

const getTrackOnLoadResultsOptions = ({items, searchType, inconvenientTracking}) => {
    const vinFlights = getFilteredVinFlights(items);
    const tripType = tripTypeUtils.toAcronym(searchType);

    return {
        totalResults: inconvenientTracking.totalResults,
        totalVinFlights: vinFlights.length,
        tripType,
    };
};


const trackResultsOnLoad = (data) => {
    const options = getTrackOnLoadResultsOptions(data);

    if (options.totalVinFlights) {
        const label = `${options.tripType}_vin_n:${options.totalVinFlights}_r:${options.totalResults}`;

        trackingUtils.trackEvent('onload', label);
    }
};

const getRelativePosition = ([position] = {}) => {
    return position ? position.itinerary : -1;
};

const trackOnSelectFlight = ({fareType, searchType, positions}) => {
    const isDynpack = Odigeo.Utils.isRequestApp('dp');

    if (!isDynpack && Odigeo.Utils.isVinFlight(fareType)) {
        const tripType = tripTypeUtils.toAcronym(searchType);
        const position = getRelativePosition(positions);
        const label = `${tripType}_sel_vin_pr:${position}`;

        trackingUtils.trackEvent('vin', label);
    }
};

const getPageName = () => {
    return PAGES_TO_TRACK[Odigeo.History.getPageNameFromFragment()];
};

const getTripType = () => {
    let type;
    const searchParameters = Odigeo.Session.get('searchParameters');

    if (typeof searchParameters === 'string') {
        type = tripTypeToResultsType(Odigeo.Utils.parseJson(searchParameters).type);
    } else {
        type = searchParameters.type;
    }

    return tripTypeUtils.toAcronym(type);
};

const trackFlowEvent = () => {
    const tripType = getTripType();
    const page = getPageName();
    const label = `${tripType}_vin_pag:${page}`;
    if (page !== 'pax') {
        trackingUtils.trackEvent('vin', label);
    }
};

const trackFlowOnLoad = () => {
    const isVinFlight = Odigeo.Session.get('isVinFlight');
    const isDynpack = Odigeo.Utils.isRequestApp('dp');

    if (!isDynpack && isVinFlight) {
        trackFlowEvent();
    }
};

const trackMetaSummaryOnLoad = (isVinFlight) => {
    Odigeo.Session.set('isVinFlight', isVinFlight);

    if (isVinFlight) {
        trackFlowEvent();
    }
};

module.exports = {
    trackFlowOnLoad,
    trackMetaSummaryOnLoad,
    trackOnSelectFlight,
    trackResultsOnLoad,
};
